export { WhyChooseUs };
export default WhyChooseUs;

function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-price-tag-3-line',
      title: 'Transparent Pricing, No Surprises',
      description: `Flat $250 doc fee — one of the lowest in the region. No hidden charges, no "market adjustment" fees, no surprises at signing. The price you see online is the price you pay. We put it in writing because we mean it.`
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Built for Pacific Northwest Weather',
      description: `Every vehicle is inspected for rain, fog, and salt air durability. We check seals, undercarriage, and electrical systems. If it can't handle a Longview winter or a drive across the bridge in 40mph winds, it doesn't make our lot.`
    },
    {
      icon: 'ri-truck-line',
      title: 'Free Delivery to Your Driveway',
      description: `Live in Longview, Kelso, Ilwaco, or anywhere in SW Washington? We'll bring the car to you. No need to coordinate rides or take time off work. We cross the bridge so you don't have to.`
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Locals Helping Locals',
      description: `We're not some Seattle dealer trying to dump inventory on rural buyers. We live on the coast. We know the roads, the weather, and what actually holds up. If we sell you junk, we'll see you at the grocery store. Reputation matters.`
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            Why SW Washington Buyers Cross the Bridge
          </h2>
          <p className="text-xl text-slate-700 max-w-3xl mx-auto">
            Honest pricing, a flat $250 doc fee, and a team that actually inspects for the weather you'll be driving in.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                  <i className={`${reason.icon} text-2xl text-teal-600`}></i>
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">{reason.title}</h3>
                <p className="text-slate-700 leading-relaxed">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}